<template>
  <div>
    <Collapse v-model="value" simple style="border: 0; margin-bottom: 30px">
      <Panel
        name="1"
        hide-arrow
        style="margin: 20px 0; border: 0"
        v-show="startType.includes('绩效重点')"
      >
        <FormTitle
          :titleText="$t('Performance_Priorities_WHAT_')"
        /><!-- 绩效重点(WHAT) -->
        <div slot="content" style="margin-top: 20px">
          <div v-show="startType.includes('绩效重点')">
            <!-- 绩效重点(WHAT) -->{{ $t("Performance_Priorities_WHAT_") }}
          </div>
          <PersonalGoals
            v-show="startType.includes('绩效重点')"
            ref="PersonalGoals"
            :tabName="'goalSetting'"
            @onInter="addStatusColumn"
          ></PersonalGoals>
        </div>
      </Panel>
      <Panel
        name="5"
        hide-arrow
        style="margin: 20px 0; border: 0"
        v-show="startType.includes('STI')"
      >
        <FormTitle :titleText="$t('STI_Self')" /><!-- STI个人目标 -->
        <div slot="content" style="margin-top: 20px">
          <div v-show="startType.includes('STI')">
            <!-- STI个人目标 -->{{ $t("STI_Self") }}
          </div>
          <STIComponent
            v-show="startType.includes('STI')"
            ref="STIComponent"
            :tabName="'goalSetting'"
            @onInter="addStatusColumn"
          ></STIComponent>
        </div>
      </Panel>
      <Panel
        name="2"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="startType.includes('行为期望')"
      >
        <FormTitle
          :titleText="$t('Behavioural_Expections_How_')"
        /><!-- 行为期望(HOW) -->
        <div style="margin-top: 30px" slot="content">
          <BehaviorExpectation
            ref="BehaviorExpectation"
            :tabName="'goalSetting'"
            @onInter="addStatusColumn"
          ></BehaviorExpectation>
        </div>
      </Panel>
      <Panel
        name="6"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="startType.includes('增长文化')"
      >
        <FormTitle
          :titleText="$t('Behavioural_Expections_How_')"
        /><!-- 增长文化 -->
        <div style="margin-top: 30px" slot="content">
          <GrowthCulture
            ref="GrowthCulture"
            :tabName="'goalSetting'"
            @onInter="addStatusColumn"
          ></GrowthCulture>
        </div>
      </Panel>
      <Panel
        name="3"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="startType.includes('个人发展计划')"
      >
        <FormTitle :titleText="$t('longText11')" />
        <!-- 员工发展计划（需要考虑与3A行为准则或专业技能的差距，基于70/20/10原则，并根据实际情况进行填写发展行动中的在岗培训和经验/向他人学习/正式领导培训/正式业务培训/其他） -->
        <div slot="content" style="margin-top: 20px">
          <div><!-- 个人发展计划 -->{{ $t("Development_Plans") }}</div>
          <div style="margin-top: 30px" slot="content">
            <DevelopmentPlan
              ref="DevelopmentPlan"
              :tabName="'goalSetting'"
              @onInter="addStatusColumn"
            ></DevelopmentPlan>
          </div>
        </div>
      </Panel>
      <Panel
        name="4"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="userInfoa.id"
      >
        <FormTitle
          :titleText="$t('Approval_History') + '/' + $t('Action_History')"
        /><!-- 审批历史/操作履历 -->
        <div style="margin-top: 30px" slot="content">
          <Tabs type="card" name="sub-tabs">
            <TabPane :label="$t('Approval_History')" :index="1" tab="sub-tabs"
              ><!-- 审批历史 -->
              <ApprovalHistory
                ref="ApprovalHistory"
                @pageChangeApproval="pageChangeApproval"
              ></ApprovalHistory>
            </TabPane>
            <TabPane :label="$t('Action_History')" :index="2" tab="sub-tabs"
              ><!-- 操作履历 -->
              <OperationHistory
                ref="OperationHistory"
                @pageChangeOperation="pageChangeOperation"
              ></OperationHistory>
            </TabPane>
          </Tabs>
        </div>
      </Panel>
      <Alert v-if="startType.includes('STI')" type="error"
        >{{ $t("longText13")
        }}<!-- 员工及直属上级就绩效重点、STI个人目标、行为期望、个人发展计划等进行了讨论并达成一致 --></Alert
      >
      <Alert v-else type="error"
        >{{ $t("longText28")
        }}<!-- 员工及直属上级就绩效重点、行为期望、个人发展计划等进行了讨论并达成一致 --></Alert
      >
    </Collapse>
    <div class="btnRight" style="padding-top: 35px" v-if="cardHid">
      <Button
        :disabled="submitFlag"
        type="primary"
        class="btn"
        v-if="
          (beApprovalFlag == '0' &&
            (applyEditFlag != '1' ||
              (userDeptFlag == '3' &&
                userDeptFlag == '4' &&
                userDeptFlag == '2'))) ||
          !targetRevisionState
        "
        @click="importCG"
        >{{ $t("Import_Draft")
        }}<!-- 导入草稿 --></Button
      >
      <Button
        :disabled="submitFlag"
        type="primary"
        class="btn"
        v-if="
          (beApprovalFlag == '0' &&
            (applyEditFlag != '1' ||
              (userDeptFlag == '3' &&
                userDeptFlag == '4' &&
                userDeptFlag == '2'))) ||
          !targetRevisionState
        "
        @click="saveCG"
        >{{ $t("Save_Draft")
        }}<!-- 保存草稿 --></Button
      >
      <Button
        :disabled="submitFlag"
        type="primary"
        class="btn"
        v-if="
          (beApprovalFlag == '0' &&
            (applyEditFlag != '1' ||
              (userDeptFlag == '3' &&
                userDeptFlag == '4' &&
                userDeptFlag == '2'))) ||
          !targetRevisionState
        "
        @click="fromCheck"
        >{{ $t("Submit")
        }}<!-- 提交 --></Button
      >
      <!-- <Button type="primary" class="btn" v-if="!isHistory"  @click="QAClick">{{$t('Q&A')}}</Button> -->
      <Button
        :disabled="submitFlag"
        type="primary"
        class="btn"
        v-if="beApprovalFlag == '1' && targetRevisionState && returnFlag"
        @click="(approvalFlag = 1), approvalSave()"
        >{{ $t("Approves") }}</Button
      >
      <Button
        :disabled="submitFlag"
        type="primary"
        class="btn"
        v-if="
          beApprovalFlag == '1' &&
          userDeptFlag != '1' &&
          targetRevisionState &&
          returnFlag
        "
        @click="(approvalFlag = 2), approvalSave()"
        >{{ $t("Reject") }}</Button
      >
      <Button
        :disabled="submitFlag"
        type="primary"
        class="btn"
        v-if="isHistory && returnFlag"
        @click="returnApply"
        >{{ $t("Return")
        }}<!-- 返回 --></Button
      >
      <Button
        @click="cxButton"
        :disabled="submitFlag"
        class="btn"
        type="primary"
        v-if="revokeFlag == '1'"
        >撤销
      </Button>
      <Button
        :disabled="submitFlag"
        type="primary"
        class="btn"
        v-if="!isHistory && targetRevisionState"
        @click="targetRevision"
        >{{ $t("Objective_Revision")
        }}<!-- 目标修订 --></Button
      >
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <!-- 草稿模板列表 -->
    <j2-DraftTemplate
      ref="cgTem"
      @getCGDa="getCGDa1"
      @spinShowFalse="spinShowFalse"
    />
    <j2-DraftPop ref="cgPop" @spinShow="spinShowFalse" />
    <QAComponent ref="qaComponent"></QAComponent>
    <ApprovalRemark ref="ApprovalRemark" @ok="approvalOk"></ApprovalRemark>
  </div>
</template>

<script>
import PersonalGoals from "./PersonalGoals";
import STIComponent from "./STIComponent";
import BehaviorExpectation from "./BehaviorExpectation";
import GrowthCulture from "./GrowthCulture";
import DevelopmentPlan from "./DevelopmentPlan";
import axios from "axios";
import QAComponent from "@/components/process/Apply/components/QAComponent";
import ApprovalRemark from "../modalComponents/ApprovalRemark.vue";
import ApprovalHistory from "./ApprovalHistory";
import OperationHistory from "./OperationHistory";
export default {
  components: {
    PersonalGoals,
    STIComponent,
    BehaviorExpectation,
    DevelopmentPlan,
    GrowthCulture,
    QAComponent,
    ApprovalRemark,
    ApprovalHistory,
    OperationHistory,
  },
  data() {
    return {
      value: [1, 2, 3, 4, 5, 6],
      isHistory: false,
      status: "",
      userInfo: {},
      userInfoa: {},
      // 是否能够撤销
      revokeFlag: "0",
      // 撤销传的status
      applyStatus: "0",
      // 撤销传的id
      applyId: "",
      spinShow: false,
      reportId: "",
      userDeptFlag: "",
      applyEditFlag: "",
      qaId: "",
      startType: "",
      beApprovalFlag: "",
      targetRevisionState: true,
      beUpdateFlag: "",
      approvalFlag: 0,
      cardHid: true,
      targetUpdateButton: "",
      updateApprovalFlag: "",
      updateFlag: false,
      returnFlag: true,
      submitFlag: false,
    };
  },
  computed: {
    //2026新内容是否生效
    isNCTE() {
      let flag = false;
      let nowDate = this.$nowDate.dateVal(new Date(), "YYYY");
      if (nowDate <= this.userInfo.year) {
        flag = true;
      }
      return flag;
    },
  },
  created() {},
  watch: {
    userInfo(newVal, oldVal) {
      this.userInfoa = newVal;
    },
  },
  mounted() {},
  methods: {
    // 撤销
    cxButton() {
      this.$Modal.confirm({
        title: "请确认是否撤销",
        onOk: () => {
          axios
            .post("/achApply/revokeTarget", {
              id: this.applyId,
              status: this.applyStatus,
            })
            .then((res) => {
              if (res) {
                this.$emit("addModalWarning");
                this.$Message.success("撤销成功");
              }
            });
        },
      });
    },
    importCG() {
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_import"),
        onOk: () => {
          this.$refs.cgTem.getInternation();
          //草稿type 操作人
          this.$refs.cgTem.importClick2(
            "ACH01",
            JSON.parse(sessionStorage.getItem("userInfo")).userId
          );
          this.spinShow = true;
        },
      });
    },
    spinShowFalse() {
      this.spinShow = false;
    },
    saveCG() {
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_save"),
        onOk: () => {
          this.spinShow = true;
          // 需要重新刷新定时器
          this.$emit("beginTime", "1");
          let obj = {
            achKeyNoteInfoList: this.$refs.PersonalGoals.data1,
            stiTargetInfoList: this.$refs.STIComponent.data1,
            expectInfoList: this.$refs.BehaviorExpectation.data5,
            developmentPlanList: this.$refs.DevelopmentPlan.data5,
            growthCultureList: this.$refs.GrowthCulture.data5,
          };
          this.$refs.cgPop.handleSubmit("ACH01", { formItem: obj });
        },
      });
      // this.$refs.cgPop.getInternation();
      //草稿type 草稿内容
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      // this.$refs.cgPop.getInternation();
      //草稿type 草稿内容
      this.spinShow = true;
      // this.getData(this.userInfoa)
      var obj = JSON.parse(row.draftContent);
      this.$refs.PersonalGoals.data1 = obj.formItem.achKeyNoteInfoList;
      this.$refs.PersonalGoals.oldData = obj.formItem.achKeyNoteInfoList;
      if (obj.formItem.achKeyNoteInfoList.length > 0) {
        let max = Number(this.$refs.PersonalGoals.data1[0].commonId);
        for (let i = 1; i < this.$refs.PersonalGoals.data1.length; i++) {
          max =
            max > Number(this.$refs.PersonalGoals.data1[i].commonId)
              ? max
              : Number(this.$refs.PersonalGoals.data1[i].commonId);
        }
        this.$refs.PersonalGoals.kpiIdNum = max + 1;
      }
      this.$refs.PersonalGoals.tableSpan();
      this.$refs.STIComponent.data1 = obj.formItem.stiTargetInfoList;
      this.$refs.STIComponent.oldData = obj.formItem.stiTargetInfoList;
      let list = obj.formItem.expectInfoList;
      let array = [];
      if (list.length > 0) {
        this.$refs.BehaviorExpectation.data5.forEach((element) => {
          list.forEach((item) => {
            if (
              element.criterionType == item.criterionType ||
              element.criterionType == item.criterionTypeCode
            ) {
              item.activesPerformed = element.activesPerformed;
              item.criterionType = element.criterionType;
              array.push({ ...element, ...item });
            }
          });
        });
        this.$refs.BehaviorExpectation.data5 = array;
        this.$refs.BehaviorExpectation.oldData = array;
      }
      // 2025 追加 增长文化
      let growthList = obj.formItem.growthCultureList;
      let growthArray = [];
      if (growthList.length > 0) {
        this.$refs.GrowthCulture.data5.forEach((element) => {
          growthList.forEach((item) => {
            if (
              element.criterionType == item.criterionType ||
              element.criterionType == item.criterionTypeCode
            ) {
              item.activesPerformed = element.activesPerformed;
              item.criterionType = element.criterionType;
              growthArray.push({ ...element, ...item });
            }
          });
        });
        this.$refs.GrowthCulture.data5 = growthArray;
        this.$refs.GrowthCulture.oldData = growthArray;
        this.setGrowthCultureData();
      }

      this.$refs.DevelopmentPlan.data5 = obj.formItem.developmentPlanList;
      this.$refs.DevelopmentPlan.oldData = obj.formItem.developmentPlanList;
      this.$nextTick(() => {
        setTimeout(() => {
          this.spinShow = false;
        }, 1000);
      });
    },
    setGrowthCultureData() {
      if (!this.isNCTE && this.$refs.GrowthCulture.data5.length > 0) {
        let allMesg = "";
        this.$refs.GrowthCulture.data5.map((item) => {
          if (item.expectDetails) {
            allMesg += item.expectDetails + ";\n";
          }
        });
        this.$refs.GrowthCulture.data5[0].expectDetails = allMesg;
      }
    },
    getData(item) {
      this.spinShow = true;
      this.submitFlag = true;
      axios
        .post("/achApply/selectApplyDetails", {
          achStage: "目标设定",
          id: this.reportId,
          serialnumber: item.serialnumber,
          year: item.year,
        })
        .then((res) => {
          if (res) {
            this.revokeFlag = res.flagMap.revokeFlag;
            this.applyStatus = res.applyAchInfo.status;
            this.applyId = res.applyAchInfo.id;
            this.startType = res.applyAchInfo.startType;
            this.$refs.PersonalGoals.data1 = res.achKeyNoteInfoList;
            if (res.achKeyNoteInfoList.length > 0) {
              let max = Number(this.$refs.PersonalGoals.data1[0].commonId);
              for (let i = 1; i < this.$refs.PersonalGoals.data1.length; i++) {
                max =
                  max > Number(this.$refs.PersonalGoals.data1[i].commonId)
                    ? max
                    : Number(this.$refs.PersonalGoals.data1[i].commonId);
              }
              this.$refs.PersonalGoals.kpiIdNum = max + 1;
              this.$refs.PersonalGoals.data1.forEach((el) => {
                if (res.flagMap.applyEditFlag == 0) {
                  el.deleteState = true;
                } else {
                  el.deleteState = false;
                }
              });
            }

            this.$refs.PersonalGoals.tableSpan();
            this.$refs.STIComponent.data1 = res.stiTargetInfoList;
            let list = res.expectInfoList;
            let array = [];
            if (list.length > 0) {
              this.$refs.BehaviorExpectation.data5.forEach((element) => {
                list.forEach((item) => {
                  if (element.criterionType == item.criterionType) {
                    array.push({ ...element, ...item });
                  }
                });
              });
              this.$refs.BehaviorExpectation.data5 = array;
            }

            this.$refs.DevelopmentPlan.data5 = res.developmentPlanList;

            // 2025 01-13 追加 增长文化 查询赋值
            let growthCulturelist = res.growthCultureList;
            let growArray = [];
            if (growthCulturelist.length > 0) {
              this.$refs.GrowthCulture.data5.forEach((element) => {
                growthCulturelist.forEach((item) => {
                  if (element.criterionType == item.criterionType) {
                    growArray.push({ ...element, ...item });
                  }
                });
              });
              this.$refs.GrowthCulture.data5 = growArray;
              this.setGrowthCultureData();
            }

            res.applyAchInfo.empCode ? (this.userInfoa = res.applyAchInfo) : "";
            res.applyAchInfo.status
              ? ((this.userInfoa.status = res.applyAchInfo.status),
                (this.userInfo.status = res.applyAchInfo.status))
              : "";
            this.$refs.PersonalGoals.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.STIComponent.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.BehaviorExpectation.applyEditFlag =
              res.flagMap.applyEditFlag;
            this.$refs.DevelopmentPlan.applyEditFlag =
              res.flagMap.applyEditFlag;
            // 2025 追加传入 增长文化赋值字段
            this.$refs.GrowthCulture.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.PersonalGoals.userDeptFlag = res.flagMap.userDeptFlag;
            this.$refs.STIComponent.userDeptFlag = res.flagMap.userDeptFlag;
            this.$refs.BehaviorExpectation.userDeptFlag =
              res.flagMap.userDeptFlag;
            this.$refs.GrowthCulture.userDeptFlag = res.flagMap.userDeptFlag;
            this.$refs.DevelopmentPlan.userDeptFlag = res.flagMap.userDeptFlag;
            this.userDeptFlag = res.flagMap.userDeptFlag;
            this.applyEditFlag = res.flagMap.applyEditFlag;
            this.beApprovalFlag = res.flagMap.beApprovalFlag;
            this.targetUpdateButton = res.flagMap.targetUpdateButton;
            if (res.applyAchInfo.id) {
              this.getApprovalData();
              this.getOperationData();
            }
            this.$refs.PersonalGoals.oldData = JSON.parse(
              JSON.stringify(this.$refs.PersonalGoals.data1)
            );
            this.$refs.STIComponent.oldData = JSON.parse(
              JSON.stringify(this.$refs.STIComponent.data1)
            );
            this.$refs.DevelopmentPlan.oldData = JSON.parse(
              JSON.stringify(this.$refs.DevelopmentPlan.data5)
            );
            this.$refs.BehaviorExpectation.oldData = JSON.parse(
              JSON.stringify(this.$refs.BehaviorExpectation.data5)
            );
            // 2025 追加传入 增长文化赋值字段
            this.$refs.GrowthCulture.oldData = JSON.parse(
              JSON.stringify(this.$refs.GrowthCulture.data5)
            );
            if (res.flagMap.updateApprovalFlag == "1") {
              this.updateApprovalFlag = "1";
              this.addStatusColumn();
            }
            // this.addStatusColumn()
            // 未提交，撤销，是本人
            if (
              (res.applyAchInfo.status == "0" ||
                res.applyAchInfo.status == "93") &&
              (res.applyAchInfo.serialnumber ==
                JSON.parse(sessionStorage.getItem("userInfo")).serialnumber ||
                !res.applyAchInfo.serialnumber)
            ) {
              this.$emit("beginTime", "1");
            } else {
              this.$emit("beginTime", "0");
            }
          }
          this.spinShow = false;
          this.submitFlag = false;
        });
    },
    getApprovalData() {
      axios
        .post("/achReport/selectApprovalHistoryList ", {
          achStage: "目标设定",
          id: this.userInfoa.id,
          ...this.$refs.ApprovalHistory.pageInfo,
        })
        .then((res) => {
          this.$refs.ApprovalHistory.data = res.data;
          this.$refs.ApprovalHistory.total = parseInt(res.pageInfo.total);
        });
    },
    getOperationData() {
      axios
        .post("/achReport/selectOperationHistoryList", {
          achStage: "目标设定",
          id: this.userInfoa.id,
          ...this.$refs.OperationHistory.pageInfo,
        })
        .then((res) => {
          this.$refs.OperationHistory.data = res.data;
          this.$refs.OperationHistory.total = parseInt(res.pageInfo.total);
        });
    },
    pageChangeApproval(item) {
      this.getApprovalData();
    },
    pageChangeOperation(item) {
      this.getOperationData();
    },
    submit() {
      this.userInfoa = { ...this.userInfoa, ...this.userInfo };
      let growthCultureList = JSON.parse(
        JSON.stringify(this.$refs.GrowthCulture.data5)
      );
      let growthCultureInfo1 = growthCultureList[0] || {};
      growthCultureList.map((item) => {
        item.expectDetails = growthCultureInfo1.expectDetails;
      });
      let obj = {
        achStage: "目标设定",
        createUser: JSON.parse(sessionStorage.getItem("userInfo")).serialnumber,
        applyAchInfo: {
          ...this.userInfoa,

          // serialnumber:this.userInfo.serialnumber,
          applyUserName: this.userInfoa.userName || this.userInfo.userName,
          beReport: "0",
          achTypeUser: this.userInfoa.achTypeUser,
          beUpdateFlag: !this.targetRevisionState ? "1" : "",
          startType: this.startType,
        },
        achKeyNoteInfoList: this.$refs.PersonalGoals.data1,
        stiTargetInfoList: this.$refs.STIComponent.data1,
        expectInfoList: this.$refs.BehaviorExpectation.data5,
        developmentPlanList: this.$refs.DevelopmentPlan.data5,
        growthCultureList: growthCultureList,
      };
      this.spinShow = true;
      this.submitFlag = true;
      axios.post("/achApply/saveAchApplyInfo", obj).then((res) => {
        if (res) {
          this.$Message.success(res);
          if (this.targetRevisionState == false) {
            this.targetRevisionState = true;
            this.$refs.PersonalGoals.targetRevisionState = true;
            this.$refs.STIComponent.targetRevisionState = true;
            this.$refs.BehaviorExpectation.targetRevisionState = true;
            this.$refs.DevelopmentPlan.targetRevisionState = true;
            // 2025 追加增长文化 传值
            this.$refs.GrowthCulture.targetRevisionState = true;
            if (
              this.$refs.PersonalGoals.columns1[7] &&
              this.$refs.PersonalGoals.columns1[7].slot == "status"
            ) {
              this.$refs.PersonalGoals.columns1.splice(7, 1);
            }
            if (
              this.$refs.STIComponent.columns1[8] &&
              this.$refs.STIComponent.columns1[8].slot == "status"
            ) {
              this.$refs.STIComponent.columns1.splice(8, 1);
            }
            if (
              this.$refs.DevelopmentPlan.columns5[5] &&
              this.$refs.DevelopmentPlan.columns5[5].slot == "status"
            ) {
              this.$refs.DevelopmentPlan.columns5.splice(5, 1);
            }
            if (
              this.$refs.BehaviorExpectation.columns5[3] &&
              this.$refs.BehaviorExpectation.columns5[3].slot == "status"
            ) {
              this.$refs.BehaviorExpectation.columns5.splice(3, 1);
            }
            // 2025 追加增长文化 传值
            if (
              this.$refs.GrowthCulture.columns5[3] &&
              this.$refs.GrowthCulture.columns5[3].slot == "status"
            ) {
              this.$refs.GrowthCulture.columns5.splice(3, 1);
            }
          }
        }
        this.spinShow = false;
        this.getData(this.userInfoa);
        this.submitFlag = false;
      });
    },
    returnApply() {
      this.$router.back();
    },
    fromCheck() {
      if (
        this.$refs.PersonalGoals.data1.length == 0 ||
        this.$refs.PersonalGoals.data1.filter((el) => el.achKeyNote == "")
          .length > 0
      ) {
        this.$Message.error(this.$t("My_Performance_mess1"));
        return;
      }
      if (this.startType.includes("STI")) {
        if (
          this.$refs.STIComponent.data1.length == 0 ||
          this.$refs.STIComponent.data1.filter((el) => el.stiTarget == "")
            .length > 0
        ) {
          this.$Message.error(this.$t("My_Performance_mess2"));
          return;
        }
      }

      if (
        this.$refs.DevelopmentPlan.data5.filter((el) => el.ability == "")
          .length > 0 ||
        this.$refs.DevelopmentPlan.data5.filter((el) => el.developTarget == "")
          .length > 0 ||
        this.$refs.DevelopmentPlan.data5.filter((el) => el.details == "")
          .length > 0 ||
        this.$refs.DevelopmentPlan.data5.filter((el) => el.startDate == "")
          .length > 0 ||
        this.$refs.DevelopmentPlan.data5.filter((el) => el.endDate == "")
          .length > 0
      ) {
        this.$Message.error(this.$t("My_Performance_mess3"));
        return;
      }
      this.$Modal.confirm({
        title: this.$t("Ach_Submit"),
        onOk: () => {
          this.submit();
        },
      });
    },
    QAClick() {
      this.$refs.qaComponent.QAModal = true;
      this.$refs.qaComponent.getUserList();
      this.qaId != "" ? (this.$refs.qaComponent.qaId = this.qaId) : "";
    },
    // QAData(val){
    //     this.qaId=val
    // },
    approvalSave() {
      this.$refs.ApprovalRemark.modalShow = true;
    },
    approvalOk(value) {
      let obj = {
        ...this.userInfoa,
        idea: value,
        decision: this.approvalFlag,
        beUpdateFlag: this.beUpdateFlag,
      };
      this.spinShow = true;
      this.submitFlag = true;
      axios.post("/AchProcess/approvalAchProcess", obj).then((res) => {
        if (res) {
          this.$Message.info(this.$t("Approval_Completed"));
          this.getData(this.userInfoa);
        }
        this.spinShow = false;
        this.submitFlag = false;
      });
    },
    targetRevision() {
      if (this.targetUpdateButton != "1") {
        if (this.targetUpdateButton == "2") {
          this.$Message.info(this.$t("My_Performance_mess4"));
          return;
        } else {
          this.$Message.info(this.$t("My_Performance_mess5"));
          return;
        }
      }
      if (
        this.userInfoa.status < 2 ||
        this.userInfoa.status == 90 ||
        this.userInfoa.status == 93
      ) {
        this.$Message.info(this.$t("My_Performance_mess6"));
        return;
      }
      if (this.userInfoa.status == 8 || this.userInfoa.status == 9) {
        this.$Message.info(this.$t("STIUpdateCheck"));
        return;
      }
      if (
        this.$refs.PersonalGoals.columns1[7] &&
        this.$refs.PersonalGoals.columns1[7].slot == "status"
      ) {
        return;
      }
      if (
        this.$refs.STIComponent.columns1[8] &&
        this.$refs.STIComponent.columns1[8].slot == "status"
      ) {
        return;
      }
      if (
        this.$refs.DevelopmentPlan.columns5[5] &&
        this.$refs.DevelopmentPlan.columns5[5].slot == "status"
      ) {
        return;
      }
      if (
        this.$refs.BehaviorExpectation.columns5[5] &&
        this.$refs.BehaviorExpectation.columns5[3].slot == "status"
      ) {
        return;
      }
      // 2025 追加增长文化
      if (
        this.$refs.GrowthCulture.columns5[5] &&
        this.$refs.GrowthCulture.columns5[3].slot == "status"
      ) {
        return;
      }
      this.targetRevisionState = false;
      this.$refs.PersonalGoals.targetRevisionState = false;
      this.$emit("beginTime", "1");
      this.$refs.PersonalGoals.columns1.splice(7, 0, {
        title: this.$t("Status"),
        slot: "status",
        align: "center",
        minWidth: 120,
      });
      this.$refs.PersonalGoals.data1.forEach((res, i) => {
        res.status = "";
        this.$set(this.$refs.PersonalGoals.data1[i], "status", "");
        this.$set(this.$refs.PersonalGoals.oldData[i], "status", "");
        // 如果当前条数据的 commid 仅存在一条 则 "-" 按钮置灰
        let flag = this.$refs.PersonalGoals.data1.filter((e) => {
          if (this.$refs.PersonalGoals.data1[i].commonId == e.commonId) {
            return this.$refs.PersonalGoals.data1[i];
          }
        });
        if (flag.length == 1) {
          this.$set(this.$refs.PersonalGoals.data1[i], "deleteState", false);
          this.$set(this.$refs.PersonalGoals.oldData[i], "deleteState", false);
        } else {
          this.$set(this.$refs.PersonalGoals.data1[i], "deleteState", true);
          this.$set(this.$refs.PersonalGoals.oldData[i], "deleteState", true);
        }
      });
      this.$refs.STIComponent.targetRevisionState = false;
      this.$refs.STIComponent.columns1.splice(8, 0, {
        title: this.$t("Status"),
        slot: "status",
        align: "center",
        minWidth: 120,
      });
      this.$refs.STIComponent.data1.forEach((res, i) => {
        res.status = "";
        this.$set(this.$refs.STIComponent.data1[i], "status", "");
        this.$set(this.$refs.STIComponent.oldData[i], "status", "");
      });
      this.$refs.BehaviorExpectation.columns5.splice(3, 0, {
        title: this.$t("Status"),
        slot: "status",
        align: "center",
        minWidth: 120,
      });
      this.$refs.BehaviorExpectation.data5.forEach((res, i) => {
        res.status = "";
        this.$set(this.$refs.BehaviorExpectation.data5[i], "status", "");
        this.$set(this.$refs.BehaviorExpectation.oldData[i], "status", "");
      });
      // 2025 追加增长文化
      this.$refs.GrowthCulture.columns5.splice(3, 0, {
        title: this.$t("Status"),
        slot: "status",
        align: "center",
        minWidth: 120,
      });
      this.$refs.GrowthCulture.data5.forEach((res, i) => {
        res.status = "";
        this.$set(this.$refs.GrowthCulture.data5[i], "status", "");
        this.$set(this.$refs.GrowthCulture.oldData[i], "status", "");
      });
      this.$refs.GrowthCulture.targetRevisionState = false;
      this.$refs.BehaviorExpectation.targetRevisionState = false;
      this.$refs.DevelopmentPlan.targetRevisionState = false;
      this.$refs.DevelopmentPlan.columns5.splice(5, 0, {
        title: this.$t("Status"),
        slot: "status",
        align: "center",
        minWidth: 120,
      });
      this.$refs.DevelopmentPlan.data5.forEach((res, i) => {
        res.status = "";
        this.$set(this.$refs.DevelopmentPlan.data5[i], "status", "");
        this.$set(this.$refs.DevelopmentPlan.oldData[i], "status", "");
      });
      this.updateFlag = true;
    },
    addStatusColumn() {
      if (this.updateApprovalFlag == "1" || this.updateFlag) {
        if (
          this.$refs.PersonalGoals.columns1[7] &&
          this.$refs.PersonalGoals.columns1[7].slot == "status"
        ) {
          return;
        }
        if (
          this.$refs.STIComponent.columns1[8] &&
          this.$refs.STIComponent.columns1[8].slot == "status"
        ) {
          return;
        }
        if (
          this.$refs.DevelopmentPlan.columns5[5] &&
          this.$refs.DevelopmentPlan.columns5[5].slot == "status"
        ) {
          return;
        }
        if (
          this.$refs.BehaviorExpectation.columns5[5] &&
          this.$refs.BehaviorExpectation.columns5[3].slot == "status"
        ) {
          return;
        }
        this.$refs.PersonalGoals.columns1.splice(7, 0, {
          title: this.$t("Status"),
          slot: "status",
          align: "center",
          minWidth: 120,
        });
        this.$refs.STIComponent.columns1.splice(8, 0, {
          title: this.$t("Status"),
          slot: "status",
          align: "center",
          minWidth: 120,
        });
        this.$refs.BehaviorExpectation.columns5.splice(3, 0, {
          title: this.$t("Status"),
          slot: "status",
          align: "center",
          minWidth: 120,
        });
        this.$refs.DevelopmentPlan.columns5.splice(5, 0, {
          title: this.$t("Status"),
          slot: "status",
          align: "center",
          minWidth: 120,
        });
      }
    },
  },

  beforeDestroy() {
    this.$refs.PersonalGoals.targetRevisionState = true;
    this.targetRevisionState = true;

    if (
      this.$refs.PersonalGoals.columns1[7] &&
      this.$refs.PersonalGoals.columns1[7].slot == "status"
    ) {
      this.$refs.PersonalGoals.columns1.splice(7, 1);
    }
    if (
      this.$refs.STIComponent.columns1[8] &&
      this.$refs.STIComponent.columns1[8].slot == "status"
    ) {
      this.$refs.STIComponent.columns1.splice(8, 1);
    }
    if (
      this.$refs.DevelopmentPlan.columns5[5] &&
      this.$refs.DevelopmentPlan.columns5[5].slot == "status"
    ) {
      this.$refs.DevelopmentPlan.columns5.splice(5, 1);
    }
    if (
      this.$refs.BehaviorExpectation.columns5[3] &&
      this.$refs.BehaviorExpectation.columns5[3].slot == "status"
    ) {
      this.$refs.BehaviorExpectation.columns5.splice(3, 1);
    }
  },
};
</script>

<style lang="less" scoped>
.btnRight {
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  padding-bottom: 15px;
  left: 220px;
  z-index: 99;
  box-shadow: 0px -5px 10px -2px rgba(0, 0, 0, 0.2);
  .btn {
    margin-right: 15px;
    // margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/GoalSetting.vue